import { ChevronDownIcon, UsersIcon } from 'lucide-react'

import { RENEWAL_EVENTS, useEmitEmployerRenewalsEvent } from 'apps/employer_renewals/events'
import useRenewalEmployees from 'apps/employer_renewals/hooks/useRenewalEmployees'
import { useAllowances } from 'apps/employer_renewals/providers/AllowancesProvider'
import { DropdownMenu, TextButton } from 'slab'

export default function EmployeeFilterSelect () {
  const { eligibleEmployeeIds, enrolledEmployeeIds, isLoading } = useRenewalEmployees({})
  const { emitEvent } = useEmitEmployerRenewalsEvent()
  const { employeeFilter, setEmployeeFilter } = useAllowances()

  if (isLoading) {
    return <div />
  }

  const eligibleText = `${eligibleEmployeeIds.size} employees eligible`
  const enrolledText = `${enrolledEmployeeIds.size} employees currently enrolled`

  return (
    <DropdownMenu
      trigger={
        <div>
          <TextButton leftIcon={UsersIcon} rightIcon={ChevronDownIcon}>
            {employeeFilter === 'eligible' ? eligibleText : enrolledText}
          </TextButton>
        </div>
      }
    >
      <DropdownMenu.Item onSelect={() => {
        setEmployeeFilter('eligible')
        emitEvent(RENEWAL_EVENTS.EMPLOYEE_FILTER_CHANGED, {
          employee_filter: 'eligible',
        })
      }}
      >
        {eligibleText}
      </DropdownMenu.Item>
      <DropdownMenu.Item onSelect={() => {
        setEmployeeFilter('enrolled')
        emitEvent(RENEWAL_EVENTS.EMPLOYEE_FILTER_CHANGED, {
          employee_filter: 'enrolled',
        })
      }}
      >
        {enrolledText}
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}
